<header class="header">
  <div class="header-top">
    <div class="header-body">
      <div *ngIf="showAvatar" class="header-avatar">
        <reb-ngx-avatar
          [firstChar]="avatarFirstName"
          [lastChar]="avatarLastName"
          size="medium"
          fontColor="#FFFFFF"
          backgroundColor="#9B51F2"
        ></reb-ngx-avatar>
      </div>
      <div class="header-info">
        <reb-ngx-heading-label size="h2" weight="500">
          {{ title }}</reb-ngx-heading-label
        >
        <reb-ngx-heading-label *ngIf="subTitle" size="h6" weight="400">
          <ng-container *ngIf="!subTitleRedirect">
            {{ subTitle }}
          </ng-container>
          <ng-container *ngIf="subTitleRedirect">
            <a  class="custom-mat-link active" [routerLink]="subTitleRedirect">{{ subTitle }}</a>
          </ng-container>
         </reb-ngx-heading-label
        >
      </div>
      <!-- defines post title elements -->
      <ng-content select="#post-info"></ng-content>
    </div>
    <!-- defines the header actions -->
    <ng-content select="#top-actions"></ng-content>
  </div>
  <div class="header-bottom" *ngIf="useTabs">
    <!-- defines the tabs -->
    <ng-content select="#tabs"></ng-content>
    <!-- defines the bottom header actions -->
    <ng-content select="#bottom-actions"></ng-content>
  </div>
</header>
